
import Chip from '@/lib/components/Shared/Chip.vue';
import { defineComponent, PropType } from 'vue';
import { useController } from '@/domain/services/Composer';
import { profilePhotoController, Props, View } from './ProfilePhoto.controller';
import { ProfilePhoto, ProfilePhotoSize } from './ProfilePhoto.types';

export default defineComponent<Props, View>({
	name: 'ProfilePhoto',

	components: {
		Chip,
	},

	props: {
		profilePhoto: {
			type: Object as PropType<ProfilePhoto>,
			required: true,
		},
		size: {
			type: String as PropType<ProfilePhotoSize>,
			default: ProfilePhotoSize.Medium,
		},
	},

	setup: useController(profilePhotoController, 'profilePhotoController') as () => View,
});
